// extracted by mini-css-extract-plugin
export default {"Card":"UsersStatisticsCard_Card__MwXeJ","Top":"UsersStatisticsCard_Top__6QBPf"};